import { Scope } from '../../shared';

export const seasonalityAdjustmentPage = {
  id: 'seasonality-adjustment',
  name: _TL_('Seasonality adjustment'),
  oldUIScope: [Scope.Account],
  children: [
    {
      id: 'seasonality-adjustment',
      name: _TL_('Seasonality adjustment'),
      route: 'seasonalityadjustment',
      checkPermission: permissions =>
        permissions.dynamic.SeasonalityAdjustment
        // moved to sub-item under "planning/bid-strategies" rather than standlong item
        && !(permissions.IsDataExclusionEnabled || permissions.dynamic.DataExclusions),
    },
  ],
};

